<script lang="ts">
    import { STEP_FORM_LIST } from '../constants/common';

    import webp from '@/actions/webp';
</script>

<div class="main-container">
    <div class="title">Pasos para solicitar</div>
    <div class="apply-step-form">
        {#each STEP_FORM_LIST as step, i}
            <div class="benefit-item">
                <div class="top-image">
                    <img use:webp src={step.stepIcon} alt="" />
                </div>
                <div
                    class="benefit-item-title"
                    class:benefit-item-title--third={i === 2}
                >
                    {step.title}
                </div>
            </div>
            {#if i < STEP_FORM_LIST.length - 1}
                <div class="arrow-between" aria-hidden="true">
                    <img use:webp src={step.arrowIcon} alt="" />
                </div>
            {/if}
        {/each}
    </div>
</div>

<style lang="scss" scoped>
    .main-container {
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        padding: 60px 40px 40px 40px;
    }

    .title {
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        line-height: 40px;
        color: #0c0c0d;
    }

    .apply-step-form {
        margin-top: 24px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        background-color: #ffffff;

        .benefit-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1 1 0;
            min-width: 0;
            text-align: center;
        }

        .top-image {
            width: 108px;
            height: 108px;
            flex-shrink: 0;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                display: block;
            }
        }

        .benefit-item-title {
            margin-top: 12px;
            width: 156px;
            font-size: 24px;
            line-height: 28px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            &.benefit-item-title--third {
                width: 180px;
            }
        }

        .arrow-between {
            flex: 0 0 32px;
            width: 32px;
            height: 108px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            img {
                width: 32px;
                height: 32px;
                object-fit: contain;
                display: block;
            }
        }
    }
</style>
